<app-compliance-nav [activeMenuItem]="'tplComplianceReport'"></app-compliance-nav>


<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="50">
    <button mat-raised-button color="primary" style="margin-right: 10px;" [disabled]="isLoading" (click)="gotoPrevMonth()">Previous</button>
    <button mat-raised-button color="primary" [disabled]="isLoading" (click)="gotoNextMonth()">Next</button>

  </div>

</div>

<mat-card>


  <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="column">
      <div>

      </div>
    </div>

  </div>

  <div>Month: {{ monthYear }}</div>
  <ng-container *ngIf="report">
    <div>New Customers: {{ report.newCustomersCount }}</div>
    <div>Relationships Closed: {{ report.relationshipsClosedCount }}</div>
    <div>Active Customers: {{ report.activeCustomers }}</div>
    <div>Total Customers marked vulnerable by end of month: {{ report.vulnerableCustomers }}</div>
    <div>CC Report: {{ report.ccReportName }}</div>
  </ng-container>


  <div style="background-color: yellow; padding: 4px; border-radius: 4px; color: red; margin-top: 10px;">
    <div>Note! These values will change if you navigate to this page at a later date, since cards and orders may have been closed, re-opened, expired or cancelled.</div>
  </div>
  <div style="background-color: yellow; padding: 4px; border-radius: 4px; color: red; margin-top: 10px;">
    <div>These values are most accurate on the first of the month and the accuracy also depends on how close the latest CC report of the respective month is to the last day of the month</div>
  </div>

</mat-card>


